<script setup lang="ts">
import type { Inline } from '../mini-markdown';

/** Parsed inline text (see mini-markdown.ts): text, bold, code and links that open in a new tab. */
defineProps<{ parts: Inline[] }>();
</script>

<template>
  <template v-for="(p, i) in parts" :key="i">
    <strong v-if="p.k === 'b'">{{ p.s }}</strong>
    <code v-else-if="p.k === 'c'">{{ p.s }}</code>
    <a v-else-if="p.k === 'a'" :href="p.href" target="_blank" rel="noopener noreferrer">{{ p.s }}</a>
    <template v-else>{{ p.s }}</template>
  </template>
</template>
